var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import 'rxjs/add/observable/of';
import { DataSourceUtils } from '../../../shared/utils/data-source-utils';
import { getProjectsSelector, getProjectsTotalSelector } from '../projects.reducer';
import { GetProjectsWithStatsAction } from '../projects.action';
var ProjectsTableDataSource = /** @class */ (function (_super) {
    __extends(ProjectsTableDataSource, _super);
    function ProjectsTableDataSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectsTableDataSource.prototype.update = function () {
        this.store.dispatch(new GetProjectsWithStatsAction(this.params));
    };
    ProjectsTableDataSource.prototype.onConnect = function () {
        this.params = {};
        return this.store.select(getProjectsSelector).withLatestFrom(this.store.select(getProjectsTotalSelector));
    };
    return ProjectsTableDataSource;
}(DataSourceUtils));
export { ProjectsTableDataSource };
